import ConfirmationModal, { ConfirmationModalProps } from '@/components/Modals/ConfirmationModal';
import { AppRoutes } from '@/utils/types';
import { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { useSubmitTranslationDrafts } from '../../hooks/useSubmitTranslationDrafts';

function BackButtonConfirmationModal(props: Pick<ConfirmationModalProps, 'open' | 'onClose'>) {
    const { submitTranslationDrafts } = useSubmitTranslationDrafts();
    const [isLoading, setIsLoading] = useState(false);
    const navigate = useNavigate();

    async function handleSave() {
        setIsLoading(true);
        await submitTranslationDrafts();
        setIsLoading(false);
        navigate(AppRoutes.Translation);
    }

    function handleLeave() {
        navigate(AppRoutes.Translation);
    }

    return (
        <ConfirmationModal
            title="Unsaved changes"
            text="You have unsaved changes, would you like to save them?"
            primaryButtonText="Save changes"
            secondaryButtonText="Leave"
            onConfirm={handleSave}
            onSecondaryClick={handleLeave}
            isLoading={isLoading}
            {...props}
        />
    );
}

export default BackButtonConfirmationModal;
